<template>
  <ValidationObserver ref="form" v-slot="{ handleSubmit }">
    <form class="mt-4" novalidate @submit.prevent="handleSubmit(onSubmit)">
      <ValidationProvider vid="email" name="E-mail" rules="required" v-slot="{ errors }">
        <div class="form-group">
          <label for="emailInput">用户名</label>
          <input :class="'form-control mb-0' + (errors.length > 0 ? ' is-invalid' : '')" id="emailInput"
            aria-describedby="emailHelp" v-model="user.email" placeholder="输入用户名" required>
          <div class="invalid-feedback">
            <span>用户名不合法</span>
          </div>
        </div>
      </ValidationProvider>
      <ValidationProvider vid="password" name="Password" rules="required" v-slot="{ errors }">
        <div class="form-group">
          <label for="passwordInput">密码</label>
          <!-- <a class="float-right">
            忘记了密码?
          </a> -->
          <input type="password" :class="'form-control mb-0' + (errors.length > 0 ? ' is-invalid' : '')"
            id="passwordInput" v-model="user.password" placeholder="输入密码" required>
          <div class="invalid-feedback">
            <span>密码不合法</span>
          </div>
        </div>
      </ValidationProvider>
      <div class="d-inline-block w-100">
        <div class="custom-control custom-checkbox d-inline-block mt-2 pt-1">
          <!-- <input type="checkbox" class="custom-control-input" :id="formType">
          <label class="custom-control-label" :for="formType">记住凭证</label> -->
        </div>
        <button type="submit" class="btn btn-primary float-right">登录</button>
      </div>
      <div class="sign-info">
        <span class="dark-color d-inline-block line-height-2" style="display: flex;">
          <span>
            尚未拥有账号?
          </span>
          <span class="iq-waves-effect pr-4" style="color: var(--iq-primary); margin-left: 12px;">
            联系管理员获取
          </span>
        </span>
        <!-- <social-login-form></social-login-form> -->
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import auth from '../../../../services/auth'
import firebase from 'firebase'
import axiosInstance from '../../../../services/index'
// import SocialLoginForm from './SocialLoginForm'
import { core } from '../../../../config/pluginInit'
import { mapGetters } from 'vuex'

export default {
  name: 'SignIn1Form',
  // components: { SocialLoginForm },
  props: ['formType', 'email', 'password'],
  data: () => ({
    user: {
      email: '',
      password: ''
    }
  }),
  mounted() {
    this.user.email = this.$props.email
    this.user.password = this.$props.password
  },
  computed: {
    ...mapGetters({
      stateUsers: 'Setting/usersState'
    })
  },
  methods: {
    onSubmit(e) {
      if (this.formType === 'jwt' || this.formType === 'firebase') {
        axiosInstance.post('/plane/login', {
          username: this.user.email,
          password: this.user.password
        }).then((res) => {
          // 获取新数据
          // console.log(res.data)
          if (res.status === 0) {
            localStorage.setItem('USER', JSON.stringify(res.data))
            this.$router.push({ name: 'dashboard.dashboard' })
          }
        }).catch(() => {
          // console.error('创建失败:', error)
        })
      } else if (this.formType === "daili") {
        axiosInstance.post('/plane_d/login', {
          username: this.user.email,
          password: this.user.password
        }).then((res) => {
          // 获取新数据
          // console.log(res.data)
          if (res.status === 0) {
            res.data.role = 3
            localStorage.setItem('USER', JSON.stringify(res.data))
            this.$router.push({ name: 'dashboard.dashboard' })
          }
        }).catch(() => {
          // console.error('创建失败:', error)
        })
      } else {
        axiosInstance.post('/plane_s/login', {
          username: this.user.email,
          password: this.user.password
        }).then((res) => {
          // 获取新数据
          // console.log(res.data)
          if (res.status === 0) {
            res.data.role = 2
            localStorage.setItem('USER', JSON.stringify(res.data))
            this.$router.push({ name: 'dashboard.dashboard' })
          }
        }).catch(() => {
          // console.error('创建失败:', error)
        })
      }
    },
    passportLogin() {
      alert("登录")
      auth.login(this.user).then(response => {
        if (response.status) {
          localStorage.setItem('user', JSON.stringify(response.data))
          this.$router.push({ name: 'dashboard.home-1' })
        } else if (response.data.errors.length > 0) {
          this.$refs.form.setErrors(response.data.errors)
        }
      }).finally(() => { this.loading = false })
    },
    jwtLogin() {
      const selectedUser = this.stateUsers.find(user => {
        return (user.email === this.user.email && user.password === this.user.password)
      }) || null
      if (selectedUser) {
        // this.$store.dispatch('Setting/authUserAction', {
        //   auth: true,
        //   authType: 'jwt',
        //   user: {
        //     id: selectedUser.uid,
        //     name: selectedUser.name,
        //     mobileNo: null,
        //     email: selectedUser.email,
        //     profileImage: null
        //   }
        // })
        // localStorage.setItem('user', JSON.stringify(selectedUser))
        // localStorage.setItem('access_token', selectedUser.token)
        // this.$router.push({ name: 'dashboard.home-1' })
      }
    },
    firebaseLogin() {
      firebase.auth().signInWithEmailAndPassword(this.user.email, this.user.password).then((user) => {
        const firebaseUser = firebase.auth().currentUser.providerData[0]
        this.$store.dispatch('Setting/authUserAction', {
          auth: true,
          authType: 'firebase',
          user: {
            id: firebaseUser.uid,
            name: firebaseUser.displayName,
            mobileNo: firebaseUser.phoneNumber,
            email: firebaseUser.email,
            profileImage: firebaseUser.photoURL
          }
        })
        localStorage.setItem('user', JSON.stringify(firebaseUser))
        this.$router.push({ name: 'dashboard.home-1' })
      }).catch((err) => {
        if (err.code === 'auth/user-not-found') {
          core.showSnackbar('error', 'These credentials do not match our records.')
        } else {
          core.showSnackbar('error', err.message)
        }
      })
    }
  }
}
</script>
